
export default {
  data() {
    return {
      title:
        "Bicycle Shipping Reviews | Bike Shipping Reviews | Bikeflights.com",
    };
  },
  mounted() {
    // Load the Trustpilot widget when the component is mounted (page is loaded)
    const a = document?.getElementById("TPW");
    if (a) {
      window?.Trustpilot?.loadFromElement(a);
    }
  },
  head() {
    return {
      title: this.title,
      script: [
        {
          hid: "TrustPilotWidget",
          src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
          prefetch: true,
          async: true,
          defer: true,
          body: true,
        },
      ],
    };
  },
};
